import type { volcengineModelConfig, InputPayloadType } from './types';
import { volcengineModelConfigs } from './config';

/**
 * 获取模型配置
 */
export function getvolcengineModelConfig(modelId: string): volcengineModelConfig {
    const config = volcengineModelConfigs[modelId];
    if (!config) {
        throw new Error(`Model ${modelId} not found`);
    }
    return config;
}

/** 渠道是否支持火山私域素材自动提审（不支持审核时为 false） */
export function shouldReviewVolcengineAigcMaterial(modelId: string): boolean {
    const config = volcengineModelConfigs[modelId];
    return Boolean(config?.enableAigcMaterialReview);
}

/** 自动提审素材渠道：北京渠道走独立账号的素材组与缓存表 */
export function getVolcengineAigcMaterialChannel(modelId: string): 'default' | 'beijing' {
    const config = volcengineModelConfigs[modelId];
    return config?.aigcMaterialChannel === 'beijing' ? 'beijing' : 'default';
}

/**
 * 构建输入参数
 */
export async function buildInputPayloadFromConfig(
    modelId: string,
    params: {
        prompt: string;
        imagePrompt?: string[];
        videoUri?: string;
        videoUris?: string[];
        audioUri?: string;
        audioUris?: string[];
        duration: number;
        aspectRatio?: string;
        quality?: string;
        modelUi?: Record<string, any>;
        providerOptions?: Record<string, Record<string, any>>;
    }
): Promise<InputPayloadType> {
    // 获取服务商配置
    const config = getvolcengineModelConfig(modelId);

    // 构建输入参数
    const result = await config.buildInput(params);
    
    return result
}